@if (isBrowser) {
  <p-toast />

  <div class="confirm-dilouge">
    <p-confirmDialog></p-confirmDialog>
  </div>

  <logibids-user-headers></logibids-user-headers>
  <div class="main_wrp relative">
    <div class="card_view" [class.isDriverHome]="isDriverHome()">
      <router-outlet></router-outlet>
    </div>

    @if (!isTrackingRoute()) {
      <logibids-google-map />
    } @else {
      <logibids-tracking-map></logibids-tracking-map>
    }

    <logibids-map-widgets />

    <!-- driver tracking to bottom -->
    @if (isTrackingRoute()) {
      <div
        class="card_view cardview_top for_code_push right_side"
        [class.active]="isDriverEnquiryActive()"
        [ngClass]="{
          showAnimationCard: isDriverEnquiryActive(),
        }">
        <logibids-driver-enquiry />
      </div>
    }

    <!-- top to bottom -->
    @if (isDriverHomeAndProfile()) {
      <div
        class="card_view cardview_top for_code_push top_side"
        [class.active]="showList()"
        [ngClass]="{
          showAnimationCardTop: showList() === true,
        }">
        <logibids-driver-enquiry />
      </div>

      <div
        class="card_view left_side"
        [class.active]="showListImmediate()"
        [ngClass]="{
          showAnimationCard: showListImmediate() === true,
        }">
        <logibids-driver-enquiry-immediate />
      </div>
    }
  </div>
}

@if (aiOpen() && isBrowser && accessToken()) {
  <logibids-ai-cab-booking />
}
